import { makeStyles } from '@material-ui/styles'

/**
 * One column view layout
 */
export const oneColumnStyles = makeStyles((theme) => ({
	root: {
		height: '100vh',
		display: 'grid',
		gridTemplateRows: '64px auto',
		backgroundColor: theme.palette.secondary.main
	},
	header: {
		gridRow: '1/2'
	},
	content: {
		gridRow: '2/3'
	},
	appLogo: {
		height: 40
	}
}))

/**
 * Two columns view layout
 */
export const twoColumnsStyle = makeStyles((theme) => ({
	root: {
		height: '100vh',
		display: 'grid',
		gridTemplateRows: '64px auto',
		gridTemplateColumns: 'auto 1fr',
		backgroundColor: theme.palette.common.white
	},
	header: {
		gridColumn: ' 2 / 3',
		gridRow: '1 / 2'
	},
	sideBar: {
		gridColumn: ' 1 / 2',
		gridRow: '1 / 3'
	},
	content: {
		gridColumn: ' 2 / 3',
		gridRow: '2 / 3',
		backgroundColor: theme.palette.colors.grayLayout
	},
	notificationPaper: {
		zIndex: 10
	},
	contentNotifications: {
		overflowY: 'auto',
		overflowX: 'hidden',
		maxHeight: '55vh',
		maxWidth: '390px'
	},
	outlinedRoot: {
		'&:hover': {
			backgroundColor: `${theme.palette.colors.blueLight} !important`,
			color: theme.palette.colors.blue,
			borderColor: theme.palette.colors.blue
		}
	},
	rootTitle: {
		width: '100%',
		color: `${theme.palette.colors.primaryDisabled} !important`,
		backgroundColor: `${theme.palette.colors.grayLayout} !important`
	},
	notificationsHeaderRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	notificationsHeaderActions: {
		display: 'flex',
		alignItems: 'center',
		/* The two actions are different shapes — a filled square and a bare icon — so without a gap
		   they read as one control.

		   The gap matches `ListSubheader`'s right gutter (16px), which is what sits between the
		   delete button and the panel's edge. The `IconButton`'s own padding contributes equally on
		   both sides and cancels out, so making these two equal is what leaves the delete button
		   with the same visual space to its left and to its right. Changing one without the other
		   puts it off-centre again. */
		gap: theme.spacing(2)
	},
	/* The deletion is not the download's twin and must not look like it. It copies the services
	   toolbar's "Clean filters" control: a bare icon button, no filled ground, the trash glyph in
	   red. The colour is the literal `#e74c3c` that call site uses rather than the theme's
	   `colors.red` (#D92550), so the two match exactly. */
	notificationsDeleteButton: {
		'& .MuiSvgIcon-root': {
			width: '19px',
			color: '#e74c3c'
		},
		/* Without this the inline red would survive the disabled state and the control would look
		   available while doing nothing. */
		'&.Mui-disabled .MuiSvgIcon-root': {
			color: theme.palette.colors.primaryDisabled,
			opacity: 0.5
		}
	},
	/* The panel's action is the same square, filled button the services toolbar uses: navy ground,
	   white icon, same shape and same size, so the user reads one vocabulary across the portal.

	   `backgroundColor` carries `!important` because the button sits inside a `ButtonGroup` with
	   `variant='outlined'`, whose `MuiButton-outlined` rule paints a transparent ground. Without the
	   override the button renders white with a navy icon — the inverse of what it should be.

	   The rules live here instead of being imported from `useServiceTableStyles` in
	   ServicesListStyles.js: that hook belongs to the services views, and pulling it into a
	   component shared by the whole layout would couple them. The pair is duplicated, so a change to
	   the toolbar's look has to be mirrored here. */
	notificationsActionGroup: {
		boxShadow: '0px 0px 0px 0px'
	},
	notificationsActionButton: {
		display: 'flex',
		alignSelf: 'center',
		backgroundColor: `${theme.palette.primary.main} !important`,
		color: `${theme.palette.common.white} !important`,
		border: `0.5px solid ${theme.palette.colors.grayLayout}`,
		'&:hover': {
			backgroundColor: `${theme.palette.colors.primarySelected} !important`,
			color: `${theme.palette.common.white} !important`,
			border: `0.5px solid ${theme.palette.colors.grayLayout}`
		},
		'&.Mui-disabled': {
			backgroundColor: `${theme.palette.colors.primaryDisabled} !important`,
			color: `${theme.palette.common.white} !important`,
			opacity: 0.75,
			border: `0.5px solid ${theme.palette.colors.grayLayout}`
		},
		'&.MuiButton-root': {
			minWidth: '14px !important',
			height: '2rem !important'
		}
	}
}))
